import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { FLIP, PREVENT_OVERFLOW, ARROW } from '@cian/popper-fork';
import { clsx as cx } from 'clsx';
import { Popper } from '../../../internal/components/Popper';
import { CloseButton } from '../../../internal/components/CloseButton';
import { Outside } from '../../../services';
import { getStyles } from './styles';

/**
 * Компонент для создания кастомных тултипов
 *
 * @export
 * @param {ICustomTooltipProps} props
 * @returns
 */
export function CustomTooltip(props) {
  var content = props.content,
    header = props.header,
    anchorRef = props.anchorRef,
    theme = props.theme,
    size = props.size,
    placement = props.placement,
    portal = props.portal,
    open = props.open,
    arrow = props.arrow,
    flip = props.flip,
    preventOverflow = props.preventOverflow,
    closeButton = props.closeButton,
    outside = props.outside,
    minHeight = props.minHeight,
    maxWidth = props.maxWidth,
    withoutPadding = props.withoutPadding,
    onClose = props.onClose,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave;
  var styles = getStyles(theme, size);
  var modifiers = React.useMemo(function () {
    return [flip && FLIP, preventOverflow && PREVENT_OVERFLOW, arrow && _objectSpread(_objectSpread({}, ARROW), {}, {
      options: {
        padding: 12
      }
    })].filter(Boolean);
  }, [flip, preventOverflow, arrow]);
  var tooltip = /*#__PURE__*/React.createElement("div", {
    className: cx(styles['tooltip'], arrow && styles['arrow_tooltip'], closeButton && styles['close_tooltip'], withoutPadding && styles['without_padding']),
    style: {
      minHeight: minHeight,
      maxWidth: maxWidth
    }
  }, closeButton && /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onClose,
    className: cx(styles['close']),
    size: 12,
    theme: getCloseTheme(theme)
  }), arrow && /*#__PURE__*/React.createElement("div", {
    "data-popper-arrow": true,
    className: styles['arrow']
  }), header && /*#__PURE__*/React.createElement("div", {
    className: cx(styles['header'])
  }, header), content);
  return /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorRef: anchorRef,
    placement: placement,
    portal: portal,
    modifiers: modifiers,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, outside && /*#__PURE__*/React.createElement(Outside, {
    onOutside: onClose,
    active: true,
    insideRefs: [anchorRef]
  }, tooltip), !outside && tooltip);
}
CustomTooltip.defaultProps = {
  theme: 'white',
  size: 'S',
  placement: 'top',
  maxWidth: 450,
  portal: true,
  flip: true,
  preventOverflow: true,
  onClose: function onClose() {}
};
function getCloseTheme(tooltipTheme) {
  switch (tooltipTheme) {
    case 'black':
    case 'blue':
      return 'light';
    case 'white':
      return 'dark';
  }
}